import axios from "axios";
const api_base_url = process.env.REACT_APP_API_BASEURL;
//Login
// Check Login Details
export const checkLogin = async ({ userCreds }) => {
  try {
    const res = await axios.post(`${api_base_url}/login`, {
      Username: userCreds.Username,
      Password: userCreds.Password,
    });
    if (res) {
      if (res.status !== 200) {
        throw new Error(res.data);
      }
    } else {
      throw new Error(
        "Server Error: Please check your network or contact your administrator."
      );
    }
    return res;
  } catch (e) {
    throw e;
  }
};

export const ssoLogin = async () => {
  try {
    const returnUrl = window.location.href;
    //console.log(`${api_base_url}/saml/login?returUrl=${returnUrl}`);
    const res = await axios.get(
      `${api_base_url}/saml/login?returnUrl=${returnUrl}`
    );
    if (res) {
      //console.log("res", res);
      if (res.status !== 200) {
        throw new Error(res.data);
      }
    } else {
      throw new Error(
        "Server Error: Please check your network or contact your administrator."
      );
    }
    return res;
  } catch (e) {
    throw e;
  }
};

export const getMydata = async () => {
  return await axios.get(`${api_base_url}/login`).then((res) => {
    return res;
  });
};
//END of Login
